// ============================
// Global namespace
// ============================

const sitevars = {};

// ============================
// Document Ready
// ============================

document.addEventListener('DOMContentLoaded', () => {
    document.documentElement.classList.remove('no-js');
    initHeader();
    initModals();
    if (document.querySelector('.js-slider')) initSliders();
    if (document.querySelector('.js-nav-toggle')) initNavToggle();
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
    }
    if (typeof gsap !== 'undefined') initAnimations();
});

// ============================
// Header
// ============================

const initHeader = () => {

    const header = document.querySelector('.header');
    if (!header) return;

    let lastScrollY = window.scrollY;
    let scrollUpdatePending = false;
    let introComplete = false;

    header.classList.add('is-hidden');

    requestAnimationFrame(() => {
        header.classList.remove('is-hidden');
    });

    setTimeout(() => {
        introComplete = true;
    }, 700);

    const updateHeader = () => {

        if (!introComplete) return;

        const currentScrollY = window.scrollY;
        const scrollingDown = currentScrollY > lastScrollY;
        const isPastTop = currentScrollY > 10;

        if (!isPastTop) {

            header.classList.remove('is-hidden');
            header.classList.remove('is-visible');

            lastScrollY = currentScrollY;

            return;

        }

        if (Math.abs(currentScrollY - lastScrollY) > 5) {

            if (scrollingDown) {

                header.classList.add('is-hidden');
                header.classList.remove('is-visible');

            } else {

                header.classList.remove('is-hidden');
                header.classList.add('is-visible');

            }

        }

        lastScrollY = currentScrollY;

    };

    window.addEventListener('scroll', () => {

        if (!scrollUpdatePending) {

            window.requestAnimationFrame(() => {

                updateHeader();

                scrollUpdatePending = false;

            });

            scrollUpdatePending = true;

        }

    });

};

// ============================
// Nav toggle
// ============================

const initNavToggle = () => {
    const navToggle = document.querySelector('.js-nav-toggle');
    const nav = document.querySelector('.js-nav');
    const navMenu = document.querySelector('.js-nav-menu');

    if (!navToggle || !nav || !navMenu) return;

    navToggle.addEventListener('click', () => {
        const isOpening = !nav.classList.contains('is-active');

        if (isOpening) {
            // Open nav first
            nav.classList.add('is-active');
            navToggle.classList.add('is-active');

            // Then activate menu
            requestAnimationFrame(() => {
                navMenu.classList.add('is-active');
            });

            navToggle.setAttribute('aria-expanded', 'true');
            navToggle.setAttribute('aria-label', 'Close navigation');
        } else {
            // Remove menu active first
            navMenu.classList.remove('is-active');

            // Then remove nav active
            setTimeout(() => {
                nav.classList.remove('is-active');
                navToggle.classList.remove('is-active');
            }, 600); // match your CSS transition duration

            navToggle.setAttribute('aria-expanded', 'false');
            navToggle.setAttribute('aria-label', 'Open navigation');
        }
    });
};

// ============================
// Slider
// ============================

const createSliderStyles = swiper => {
    const wrapperEl = swiper.wrapperEl;
    const $footer = $(swiper.el).find('.swiper-footer');
    const wrapperCenterClass = 'swiper-wrapper--center';

    if (swiper.allowSlideNext && swiper.allowSlidePrev) {
        wrapperEl.classList.remove(wrapperCenterClass);
        $footer.removeClass('hidden');
    } else {
        wrapperEl.classList.add(wrapperCenterClass);
        $footer.addClass('hidden');
    }
};

const createSlider = ({
    sliderClass,
    sliderVar,
    thumbsVar,
    slidesPerView,
    slidesPerGroup,
    loop = false,
    nested = false,
    centered = false,
    spaceBetween = 0,
    breakpoints = {},
    freeMode = false,
    autoHeight = false,
    paginationType = 'bullets',
    drag = true,
    autoplay = false,
}) => {
    const thumbsSwiper = thumbsVar && sitevars[thumbsVar] ? sitevars[thumbsVar] : null;
    const reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
    ).matches;

    const slider = new Swiper(sliderClass, {
        speed: reduceMotion ? 0 : 400,
        slidesPerView,
        slidesPerGroup,
        spaceBetween,
        freeMode,
        autoHeight,
        allowTouchMove: drag,
        direction: 'horizontal',
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        watchOverflow: true,
        keyboard: {
            enabled: false,
        },
        a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            slideLabelMessage: '{{index}} of {{slidesLength}}',
        },
        autoplay: reduceMotion ? false : autoplay,
        loop,
        observer: true,
        observeParents: true,
        touchStartPropagation: false,
        touchStartForcePreventDefault: false,
        touchReleaseOnEdges: true,
        centeredSlides: centered,
        nested,
        simulateTouch: true,
        touchRatio: 1,
        hashNavigation: false,
        pagination: {
            el: `.swiper-pagination--${sliderVar}`,
            type: paginationType,
            clickable: true,
        },
        navigation: {
            nextEl: `.swiper-button-next-${sliderVar}`,
            prevEl: `.swiper-button-prev-${sliderVar}`,
            hiddenClass: '.swiper-button-hidden',
        },
        breakpoints,
        thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
        on: {
            init() {
                const jsVar = $(this.el).data('js-var');
                const $totalEl = $(
                    `.js-slider-count[data-js-var="${jsVar}"] .js-slider-item-total`,
                );
                const $currentEl = $(
                    `.js-slider-count[data-js-var="${jsVar}"] .js-slider-item-count`,
                );

                if ($totalEl.length) $totalEl.text(this.slides.length);
                if ($currentEl.length) $currentEl.text(this.realIndex + 1);

                setTimeout(() => createSliderStyles(this), 50);
            },
            observerUpdate() {
                createSliderStyles(this);
            },
            resize() {
                createSliderStyles(this);
            },
            slideChange() {
                const jsVar = $(this.el).data('js-var');
                const $currentEl = $(
                    `.js-slider-count[data-js-var="${jsVar}"] .js-slider-item-count`,
                );
                if ($currentEl.length) {
                    $currentEl.text(this.realIndex + 1);
                }
                this.slides.forEach((slide) => {
                    const isActive =
                        slide.classList.contains('swiper-slide-active');
                    slide
                        .querySelectorAll(
                            'a, button, input, textarea, select'
                        )
                        .forEach((el) => {

                            el.tabIndex = isActive ? 0 : -1;

                        });

                });

            },
        },
    });

    slider.el.addEventListener('focusin', () => {

        Object.values(sitevars).forEach((instance) => {

            if (
                instance &&
                instance.keyboard &&
                instance !== slider
            ) {
                instance.keyboard.disable();
            }

        });

        slider.keyboard.enable();

    });

    slider.el.addEventListener('focusout', (e) => {

        if (!slider.el.contains(e.relatedTarget)) {

            slider.keyboard.disable();

        }

    });

    sitevars[sliderVar] = slider;
};

const initSliders = () => {

    const sliderHandlers = [];

    document.querySelectorAll('.js-slider').forEach(($slider) => {

        const sliderEl = $slider;

        const jsVar = sliderEl.dataset.jsVar;
        const thumbsVar = sliderEl.dataset.thumbsVar;

        const slidesPerView = parseFloat(sliderEl.dataset.slidesPerView) || 1;
        const slidesPerGroup = parseInt(sliderEl.dataset.slidesPerGroup, 10) || 1;

        const drag = sliderEl.dataset.drag === 'true';
        const loop = sliderEl.dataset.loop === 'true';
        const nested = sliderEl.dataset.nested === 'true';

        const autoplay = sliderEl.dataset.autoplay === 'true';
        const autoplayDelay = parseInt(sliderEl.dataset.autoplayDelay, 10) || 3000;

        const centered = sliderEl.dataset.centered === 'true';
        const freeMode = sliderEl.dataset.freeMode === 'true';
        const autoHeight = sliderEl.dataset.autoheight === 'true';

        const paginationType = sliderEl.dataset.paginationType || 'bullets';

        const spaceBetween = parseInt(sliderEl.dataset.spaceBetween, 10) || 0;

        const initWidth = parseInt(sliderEl.dataset.init, 10) || null;
        const initDirection = sliderEl.dataset.initDirection || 'min';

        const wrapper = sliderEl.querySelector('.js-slider-init-wrapper');
        const slides = sliderEl.querySelectorAll('.js-slider-init-item');

        // Parse breakpoints
        const breakpoints = {};

        if (sliderEl.dataset.breakpoints) {

            sliderEl.dataset.breakpoints.split('&').forEach(bp => {

                const [width, vals] = bp.split('=');

                if (!width || !vals) return;

                const [slidesView, group] = vals.split(',')
                    .map(v => (isNaN(v) ? v : parseFloat(v)));

                breakpoints[parseInt(width, 10)] = {
                    slidesPerView: slidesView === 'auto'
                        ? 'auto'
                        : slidesView,

                    slidesPerGroup: group === 'auto'
                        ? 1
                        : parseInt(group, 10),
                };

            });

        }

        const autoplayConfig = autoplay
            ? {
                delay: autoplayDelay,
                disableOnInteraction: true,
                pauseOnMouseEnter: true,
            }
            : false;

        const addSwiperClasses = () => {

            sliderEl.classList.add(
                'slider',
                'swiper',
                'swiper--overflow'
            );

            sliderEl.setAttribute('role', 'region');

            sliderEl.setAttribute(
                'aria-roledescription',
                'slider'
            );

            sliderEl.setAttribute(
                'aria-label',
                `${jsVar.replaceAll('_', ' ')} slider`
            );

            if (wrapper) {
                wrapper.classList.add(
                    'slider-wrapper',
                    'swiper-wrapper',
                );
            }

            slides.forEach((slide, index) => {

                slide.classList.add(
                    'slider-item',
                    'swiper-slide',
                );

                slide.setAttribute(
                    'role',
                    'group'
                );

                slide.setAttribute(
                    'aria-roledescription',
                    'slide'
                );

                slide.setAttribute(
                    'aria-label',
                    `${index + 1} of ${slides.length}`
                );

            });

        };

        const removeSwiperClasses = () => {

            sliderEl.classList.remove('swiper');

            if (wrapper) {
                wrapper.classList.remove('swiper-wrapper');
                wrapper.removeAttribute('style');
            }

            slides.forEach((slide) => {

                slide.classList.remove('swiper-slide');

                slide.removeAttribute('style');

            });

        };

        const handleSlider = () => {

            const viewport = window.innerWidth;

            let shouldInit = true;

            // Conditional init
            if (initWidth) {

                shouldInit = initDirection === 'max'
                    ? viewport <= initWidth
                    : viewport >= initWidth;

            }

            // DESTROY
            if (!shouldInit) {

                if (sitevars[jsVar]) {

                    sitevars[jsVar].destroy(true, true);

                    sitevars[jsVar] = null;

                }

                removeSwiperClasses();

                return;

            }

            // INIT
            if (!sitevars[jsVar]) {

                addSwiperClasses();

                createSlider({
                    sliderClass: `.js-slider[data-js-var="${jsVar}"]`,
                    sliderVar: jsVar,
                    thumbsVar,
                    slidesPerView,
                    slidesPerGroup,
                    loop,
                    nested,
                    centered,
                    spaceBetween,
                    breakpoints,
                    freeMode,
                    autoHeight,
                    paginationType,
                    drag,
                    autoplay: autoplayConfig,
                });

            }

        };

        sliderHandlers.push(handleSlider);

        handleSlider();

    });

    // Global resize listener
    let resizeTimer;

    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {

            sliderHandlers.forEach((handler) => {
                handler();
            });

        }, 100);

    });

};

// ============================
// Modal actions
// ============================

const initModals = () => {

    const html = document.documentElement;

    // Open modal
    document.addEventListener('click', (e) => {

        const openBtn = e.target.closest('.js-modal-open');

        if (!openBtn) return;

        e.preventDefault();

        const modalName = openBtn.dataset.modal;
        const modal = document.querySelector(
            `.js-modal[data-modal="${modalName}"]`
        );

        if (!modal) return;

        html.classList.add('modal-is-active');
        modal.classList.add('is-active');

    });

    // Close modal button
    document.addEventListener('click', (e) => {

        const closeBtn = e.target.closest('.js-modal-close');

        if (!closeBtn) return;

        e.preventDefault();

        const modalName = closeBtn.dataset.modal;
        const modal = document.querySelector(
            `.js-modal[data-modal="${modalName}"]`
        );

        html.classList.remove('modal-is-active');

        if (modal) {
            modal.classList.remove('is-active');
        }

    });

    // Close on backdrop click
    document.addEventListener('click', (e) => {

        const modal = e.target.closest('.js-modal');

        if (!modal) return;

        const modalInner = e.target.closest('.modal-inner');

        if (modalInner) return;

        html.classList.remove('modal-is-active');
        modal.classList.remove('is-active');

    });

};

// ============================
// Animations
// ============================

const initHeroContentReveal = () => {

    gsap.fromTo(
        '.hero-body',
        {
            opacity: 0,
            y: -40,
        },
        {
            opacity: 1,
            y: 0,
            duration: 2,
            ease: 'expo.out',
        }
    );

};

const initHeroReveal = () => {

    gsap.fromTo(
        '.hero-illustration-inner',
        {
            opacity: 0,
            scale: 0.2,
        },
        {
            opacity: 1,
            scale: 1,
            duration: 1,
            stagger: 0.2,
            ease: 'expo.out',
        }
    );

};

const initHeroFloat = () => {

    gsap.utils.toArray('.hero-illustration-inner').forEach((item, index) => {

        const floatX = parseFloat(item.dataset.floatX) || 0;
        const floatY = parseFloat(item.dataset.floatY) || 10;

        gsap.to(item, {
            x: `+=${floatX}`,
            y: `+=${floatY}`,
            duration: 3 + (index * 0.4),
            repeat: -1,
            yoyo: true,
            ease: 'sine.inOut',

        });

    });

};

const initSplatterFloat = () => {

    gsap.utils.toArray('.card-splatter-bg').forEach((item, index) => {

        const driftX = gsap.utils.random(-30, 30);
        const driftY = gsap.utils.random(-40, 40);

        const rotate = gsap.utils.random(-8, 8);

        const scale = gsap.utils.random(0.96, 1.06);

        gsap.to(item, {
            x: driftX,
            y: driftY,
            rotation: rotate,
            scale,
            duration: gsap.utils.random(4, 7),
            repeat: -1,
            yoyo: true,

            ease: 'sine.inOut',
        });

        gsap.to(item, {
            x: `+=${gsap.utils.random(-10, 10)}`,
            y: `+=${gsap.utils.random(-10, 10)}`,

            duration: gsap.utils.random(2, 4),

            repeat: -1,
            yoyo: true,

            ease: 'power1.inOut',
        });

    });

};

const initScenarioFloat = () => {

    gsap.utils.toArray('.scenario-bubble-shape').forEach((item) => {

        gsap.to(item, {
            y: gsap.utils.random(-30, 30),
            x: gsap.utils.random(-20, 20),
            rotation: gsap.utils.random(-2, 5),
            duration: gsap.utils.random(5.5, 8),
            repeat: -1,
            yoyo: true,
            ease: 'sine.inOut',
        });

    });

};

const initHeroParallax = () => {

    const hero = document.querySelector('.row--hero');

    if (!hero) return;

    gsap.utils.toArray('.hero-illustration').forEach((item) => {

        const inner = item.querySelector('.hero-illustration-inner');
        if (!inner) return;

        const moveX = parseFloat(inner.dataset.scrollX) || 0;
        const moveY = parseFloat(inner.dataset.scrollY) || 0;
        const rotate = parseFloat(inner.dataset.rotate) || 0;

        gsap.to(item, {
            x: moveX,
            y: moveY,
            rotation: rotate,
            ease: 'none',
            scrollTrigger: {
                trigger: hero,
                start: 'top top',
                end: 'bottom top',
                scrub: 2,
            },
        });

    });

};

const initScrollReveal = () => {

    gsap.utils.toArray('.js-reveal').forEach((item) => {

        gsap.set(item, {
            opacity: 0,
            y: 20,
        });

        ScrollTrigger.create({
            trigger: item,
            start: 'top bottom-=100',
            once: true,

            onEnter: () => {

                gsap.to(item, {
                    opacity: 1,
                    y: 0,
                    duration: 2,
                    ease: 'expo.out',
                    clearProps: 'all',
                });

            },

        });

    });

};

const initStaggerSections = () => {

    gsap.utils.toArray('.js-stagger-section').forEach((section) => {

        const gridItems = section.querySelectorAll('.js-stagger-item');

        if (!gridItems.length) return;

        // =================================
        // Section type
        // =================================

        const isSequence = section.classList.contains(
            'js-stagger-section--sequence'
        );

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: 'top bottom-=100',
                once: true,
                invalidateOnRefresh: true,
            },
        });

        gridItems.forEach((item) => {

            const staggerElements = item.querySelectorAll('.js-stagger-element');

            const connectorLine = item.querySelector('.grid-connector-line');
            const connectorIcon = item.querySelector('.grid-connector-icon');

            // =================================
            // Initial states
            // =================================

            gsap.set(staggerElements, {
                opacity: 0,
                y: 18,
            });

            if (connectorLine) {
                gsap.set(connectorLine, {
                    scaleX: 0,
                    opacity: 0,
                });
            }

            if (connectorIcon) {
                gsap.set(connectorIcon, {
                    opacity: 0,
                    scale: 0.85,
                    x: -6,
                });
            }

            // =================================
            // Standard grid stagger
            // =================================

            if (!isSequence) {

                tl.to(staggerElements, {
                    opacity: 1,
                    y: 0,

                    duration: 1.2,
                    stagger: 0.1,

                    ease: 'expo.out',
                }, '-=0.55');

                return;

            }

            // =================================
            // Sequence stagger
            // =================================

            tl.to(staggerElements, {
                opacity: 1,
                y: 0,

                duration: 1.2,
                stagger: 0.12,

                ease: 'expo.out',
            });

            // =================================
            // Connector animations
            // =================================

            if (connectorLine || connectorIcon) {

                if (connectorLine) {

                    tl.to(connectorLine, {
                        scaleX: 1,
                        opacity: 1,

                        duration: 0.45,

                        ease: 'power2.out',
                    }, '-=0.5');

                }

                if (connectorIcon) {

                    tl.to(connectorIcon, {
                        opacity: 1,
                        scale: 1,
                        x: 0,

                        duration: 0.65,

                        ease: 'expo.out',
                    }, '-=0.35');

                }

            } else {

                tl.add('+=0.05');

            }

        });

    });

};

const initAnimations = () => {

    initHeroContentReveal();

    initHeroReveal();

    initHeroParallax();

    initScrollReveal();

    initStaggerSections();

    gsap.delayedCall(0.8, () => {
        initHeroFloat();
    });

    initSplatterFloat();

    initScenarioFloat();

};